// @flow
import * as Immutable from 'immutable';
import ImmutableModel from './ImmutableModel';

export type InputType =
    | 'DEFAULT'
    | 'PHONE'
    | 'NUMBER'
    | 'DECIMAL'
    | 'EMAIL_ADDRESS'
    | 'PASSWORD';

export type AdditionalOptionsModelType = {
    regex?: string,
    errorMessage?: string,
    inputType: InputType
};

export type ChecklistItemModelType = {
    key: string,
    format: string,
    item: string,
    possibleValues: Array<string>,
    allowedValues: Array<string>,
    optional: boolean,
    lineItemLevel: boolean,
    additionalOptions: ?AdditionalOptionsModelType,
    valueMappings: { [key: string]: string }
};

export type SelectedChecklistItemModelType = {
    id: string,
    name: string,
    selectedValue: string,
    selectedValues: ?Array<string>,
    type: string
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class ChecklistItem extends ImmutableModel {
    static fromJS(json: ChecklistItemModelType): ChecklistItem {
        const state: Object = Object.assign({}, json);
        state.possibleValues = Immutable.List(state.possibleValues);
        state.allowedValues = Immutable.List(state.allowedValues);
        state.additionalOptions = state.additionalOptions
            ? AdditionalOptions.fromJS(state.additionalOptions)
            : state.additionalOptions;
        state.valueMappings = Immutable.Map(state.valueMappings);
        return new this(Immutable.Map(state));
    }

    toJS(): ChecklistItemModelType {
        return {
            key: this.key,
            format: this.format,
            item: this.item,
            possibleValues: this.possibleValues.toArray(),
            allowedValues: this.allowedValues.toArray(),
            optional: this.optional,
            lineItemLevel: this.lineItemLevel,
            additionalOptions: this.additionalOptions
                ? this.additionalOptions.toJS()
                : this.additionalOptions,
            valueMappings: this.valueMappings.toObject()
        };
    }

    get key(): string {
        return this._state.get('key');
    }

    setKey(key: string): this {
        return this.clone(this._state.set('key', key));
    }

    get format(): string {
        return this._state.get('format');
    }

    setFormat(format: string): this {
        return this.clone(this._state.set('format', format));
    }

    get item(): string {
        return this._state.get('item');
    }

    setItem(item: string): this {
        return this.clone(this._state.set('item', item));
    }

    get possibleValues(): Immutable.List<string> {
        return this._state.get('possibleValues');
    }

    setPossibleValues(possibleValues: Immutable.List<string>): this {
        return this.clone(this._state.set('possibleValues', possibleValues));
    }

    get allowedValues(): Immutable.List<string> {
        return this._state.get('allowedValues');
    }

    setAllowedValues(allowedValues: Immutable.List<string>): this {
        return this.clone(this._state.set('allowedValues', allowedValues));
    }

    get optional(): boolean {
        return this._state.get('optional');
    }

    setOptional(optional: boolean): this {
        return this.clone(this._state.set('optional', optional));
    }

    get lineItemLevel(): boolean {
        return this._state.get('lineItemLevel');
    }

    setLineItemLevel(lineItemLevel: boolean): this {
        return this.clone(this._state.set('lineItemLevel', lineItemLevel));
    }

    get additionalOptions(): ?AdditionalOptions {
        return this._state.get('additionalOptions');
    }

    setAdditionalOptions(additionalOptions: ?AdditionalOptions): this {
        return this.clone(
            this._state.set('additionalOptions', additionalOptions)
        );
    }

    get valueMappings(): Immutable.Map<string, string> {
        return this._state.get('valueMappings');
    }

    setValueMappings(valueMappings: Immutable.Map<string, string>): this {
        return this.clone(this._state.set('valueMappings', valueMappings));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class SelectedChecklistItem extends ImmutableModel {
    static fromJS(json: SelectedChecklistItemModelType): SelectedChecklistItem {
        const state: Object = Object.assign({}, json);
        state.selectedValues = state.selectedValues
            ? Immutable.List(state.selectedValues)
            : state.selectedValues;
        return new this(Immutable.Map(state));
    }

    toJS(): SelectedChecklistItemModelType {
        return {
            id: this.id,
            name: this.name,
            selectedValue: this.selectedValue,
            selectedValues: this.selectedValues
                ? this.selectedValues.toArray()
                : this.selectedValues,
            type: this.type
        };
    }

    get id(): string {
        return this._state.get('id');
    }

    setId(id: string): this {
        return this.clone(this._state.set('id', id));
    }

    get name(): string {
        return this._state.get('name');
    }

    setName(name: string): this {
        return this.clone(this._state.set('name', name));
    }

    get selectedValue(): string {
        return this._state.get('selectedValue');
    }

    setSelectedValue(selectedValue: string): this {
        return this.clone(this._state.set('selectedValue', selectedValue));
    }

    get selectedValues(): ?Immutable.List<string> {
        return this._state.get('selectedValues');
    }

    setSelectedValues(selectedValues: ?Immutable.List<string>): this {
        return this.clone(this._state.set('selectedValues', selectedValues));
    }

    get type(): string {
        return this._state.get('type');
    }

    setType(type: string): this {
        return this.clone(this._state.set('type', type));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class AdditionalOptions extends ImmutableModel {
    static fromJS(json: AdditionalOptionsModelType): AdditionalOptions {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): AdditionalOptionsModelType {
        const js: AdditionalOptionsModelType = {
            inputType: this.inputType
        };

        if (this.regex != null) {
            js.regex = this.regex;
        }

        if (this.errorMessage != null) {
            js.errorMessage = this.errorMessage;
        }

        return js;
    }

    get regex(): ?string {
        return this._state.get('regex');
    }

    setRegex(regex: ?string): this {
        return this.clone(this._state.set('regex', regex));
    }

    get errorMessage(): ?string {
        return this._state.get('errorMessage');
    }

    setErrorMessage(errorMessage: ?string): this {
        return this.clone(this._state.set('errorMessage', errorMessage));
    }

    get inputType(): InputType {
        return this._state.get('inputType');
    }

    setInputType(inputType: InputType): this {
        return this.clone(this._state.set('inputType', inputType));
    }
}
